import type { Components } from '@mui/material/styles';

import type { Theme } from '../theme/types';
import { RadioCheckedIcon, RadioIcon } from './icons';

export const MuiRadio = {
  defaultProps: {
    checkedIcon: <RadioCheckedIcon />,
    color: 'primary',
    disableRipple: true,
    icon: <RadioIcon />,
  },
  styleOverrides: {
    root: { padding: 0 },
  },
} satisfies Components<Theme>['MuiRadio'];
